module.exports = __webpack_public_path__ + "img/Planner-icon.75e2f78f.svg";